module.exports = __webpack_public_path__ + "static/1-loving-suits-9bf5b6d1103cd6427b531c5ad20976eb.jpg";